import { graphemes } from './emoji';

/** Удаляет выделение или целую графему перед курсором, сохраняя UTF-16 позицию. */
export function emojiBackspace(text: string, start = text.length, end = start) {
  if (start !== end) return { text: text.slice(0, start) + text.slice(end), caret: start };
  if (start === 0) return { text, caret: 0 };
  let offset = 0;
  // Запасной путь объединяет составные эмодзи и в браузерах без Intl.Segmenter.
  const clusters = typeof (Intl as unknown as { Segmenter?: unknown }).Segmenter === 'function'
    ? graphemes(text)
    : text.match(/(?:\p{Regional_Indicator}{2}|[^\r\n])(?:[\p{Mark}\p{Emoji_Modifier}\u{E0020}-\u{E007F}]|\u200D[^\r\n])*|\r\n|[\r\n]/gu) ?? [];
  for (const cluster of clusters) {
    const next = offset + cluster.length;
    if (next >= start) return { text: text.slice(0, offset) + text.slice(next), caret: offset };
    offset = next;
  }
  return { text, caret: start };
}

export function backspaceInput(text: string, input: HTMLTextAreaElement | null): string {
  const result = emojiBackspace(text, input?.selectionStart, input?.selectionEnd);
  if (input) requestAnimationFrame(() => {
    input.focus();
    input.setSelectionRange(result.caret, result.caret);
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 104) + 'px';
  });
  return result.text;
}
